import Vue from 'vue'
import Vuex from 'vuex'
import PaymentService from '@/services/PaymentService.js'
import * as moment from 'moment'
import router from '@/router'
import '@/helpers/LoadingAnim.js'

Vue.use(Vuex)

const state = {
  // s3: 'https://wpg-tmp-uat.s3.ap-southeast-1.amazonaws.com/',
  s3: 'https://wpg-tmp-2023.s3.ap-southeast-1.amazonaws.com/',
  language: 'EN',
  onLoading: false,
  loadStack: 0,
  linkcode: null,
  loadingAnim: Vue.$loading,
  logo: null,
  textDisplay: null,
  amount: 0,
  total: 0,
  paid: 0,
  outstanding: 0,
  name: '',
  docNo: '',
  docDateTimeTh: '',
  docDateTimeEn: '',
  expireDateTimeTh: '',
  expireDateTimeEn: '',
  cardTokens: '',
  kcustomerID: '', // Kbank customer ID
  ref1: '',
  ref2: '',
  billBank: null,
  selectedMethod: 0,
  billData: {},
  billDataStatus: 0,
  invoicedesc: null,
  files: null,
  paycomplete: false,
  billPayment: null,
  paymentRequest: '',
  qr: '',
  storedCard: [],
  billUrl: '',
  expire: '',
  scbEasyLink: '',
  payplusLink: '', //Add Payplus Method 04/02/26
  backUrl: '',
  systemScreen:'',
  bubankInfo: null
}
const mutations = {
  LOADING(state) {
    if (!state.loadingAnim) state.loadingAnim = Vue.$loading

    state.loadStack++
    if (!state.onLoading && state.loadStack <= 1) {
      state.onLoading = true
      state.loadingAnim = state.loadingAnim.show()
    }
  },
  LOAD_DONE(state) {
    if (state.onLoading) {
      state.loadStack = state.loadStack - 1
      if (state.loadStack == 0) {
        state.onLoading = false
        state.loadingAnim = state.loadingAnim.hide()
      }
    }
  },
  UPDATE_LANGUAGE(state, newValue) {
    state.language = newValue.toUpperCase()
  },
  UPDATE_LINKCODE(state, newValue) {
    state.linkcode = newValue
  },
  UPDATE_MASTER(state, newValue) {
    // state.logo = newValue['get-logo'][0] //aod authen error
    state.textDisplay = newValue['text-display']
    state.storedCard = newValue['GetCardStoreList']
  },
  UPDATE_BILL_PAYMENT(state, newValue) {
    state.billPayment = newValue
  },
  UPDATE_BILL_DATA(state, newValue) {
    let billdata = newValue.dataheader.dataheader
    state.billData = billdata
    state.invoicedesc = newValue.dataheader.invoicedesc
    state.files = newValue.dataheader.files
    state.paycomplete = billdata.paycomplete
    state.amount = billdata.outstanding
    state.outstanding = billdata.outstanding
    state.total = billdata.total
    state.backUrl = billdata.redirecturl
    state.paid = billdata.paid
    switch (billdata.language.toUpperCase()) {
      case 'EN':
        state.name = billdata.custname_en
        break
      default:
        state.name = billdata.custname_th
    }
    state.docNo = billdata.documentno
    state.docDateTimeTh = moment(billdata.documentDatetime)
      .locale('th')
      .add(543, 'y')
      .utcOffset('+07:00')
      .format('DD MMM YYYY HH.mm')
    state.docDateTimeEn = moment(billdata.documentDatetime)
      .locale('en')
      .utcOffset('+07:00')
      .format('DD MMM YYYY HH.mm')
    let expdatetime =
      billdata.expire.slice(0, 8) + 'T' + billdata.expire.slice(8, 14)
      console.log('UPDATE_BILL_DATA expdatetime ' + expdatetime)
    state.expire = expdatetime
    state.expireDateTimeTh = moment(expdatetime)
      .locale('th')
      .add(543, 'y')
      .utcOffset('+07:00')
      .format('DD MMM YYYY เวลา HH.mm น.')
    state.expireDateTimeEn = moment(expdatetime)
      .locale('en')
      .utcOffset('+07:00')
      .format('DD MMM YYYY - HH.mm')
    state.cardTokens = billdata.cardTokens
    state.kcustomerID = billdata.kcustomerID
    state.ref1 = billdata.ref1
    state.ref2 = billdata.ref2
  },
  UPDATE_BILL_DATA_STATUS(state, newValue) {
    state.billDataStatus = newValue
  },
  UPDATE_BILL_BANK(state, newValue) {
    state.billBank = newValue.bankpayment
  },
  UPDATE_AMOUNT(state, newValue) {
    state.amount = newValue
  },
  MAX_AMOUNT(state) {
    state.amount = state.outstanding
  },
  UPDATE_QR(state, newValue) {
    state.qr = newValue
  },
  UPDATE_SCB_EASY_LINK(state, newValue) {
    state.scbEasyLink = newValue
  },
  //Add Payplus Method 04/02/26
  UPDATE_PAYPLUS_LINK(state, newValue) {
    state.payplusLink = newValue
  },
  CLEAR_BILL(state) {
    state.total = 0
    state.amount = 0
  },
  PAYMENT_REQUEST(state, data) {
    state.paymentRequest = data
  },
  SELECTED_METHOD(state, data) {
    state.selectedMethod = data
  },
  UPDATE_STORED_CARD(state, data) {
    state.storedCard = data
  },
  SET_BILL_URL(state, data) {
    state.billUrl = data
  },
  UPDATE_BUBANK_INFO(state,data){
    state.bubankInfo = data['GetBuBank']
  }
}
const actions = {
  changeAmount({ commit }, newValue) {
    commit('UPDATE_AMOUNT', newValue)
  },
  getBillDataValidated({ commit }, linkcode) {
    console.log('Store.js > getBillDataValidated =', linkcode)
    return PaymentService.getBillDataValidated(linkcode)
      .then(function (response) {
        commit('UPDATE_BILL_DATA', response.data)
        let res = response.data.dataheader.dataheader
      })
      .catch(function (error) {
        console.log(' getBillDataValidated Error ', error)
      })
      .then(function () {})
  },
  getbubankInfo({ commit }, id){
    commit('LOADING')
    let master = JSON.stringify({
      dataList: [
        {
          moduleName: 'GetBuBank',
          param: {
            bubankid: id,
          },
        }
      ],
    })
    return PaymentService.getMaster(master)
      .then(function (response) {
        let data = response.data.data
        commit('UPDATE_BUBANK_INFO',data)
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        commit('LOAD_DONE')
      })

  },
  getBill({ commit }, linkcode) {
    commit('LOADING')
    commit('UPDATE_LINKCODE', linkcode)
    let master = JSON.stringify({
      dataList: [
        {
          moduleName: 'get-logo',
          param: {
            linkcode: linkcode,
          },
        },
        {
          moduleName: 'text-display',
          param: {
            linkcode: linkcode,
          },
        },
        {
          moduleName: 'GetCardStoreList',
          param: {
            linkcode: linkcode,
          },
        },
      ],
    })
    return Promise.all([
      PaymentService.getBillBank(linkcode),
      PaymentService.getBillData(linkcode),
      PaymentService.getBillPayment(linkcode),
      PaymentService.getMaster(master),
    ])
      .then(([bank, data, payment, master]) => {
        if (bank.data) {
          commit('UPDATE_BILL_BANK', bank.data)
        }
        if (data.data.status == false || data.data.status == 'false') {
          commit('UPDATE_LINKCODE', null)
        } else {
          commit('UPDATE_BILL_DATA', data.data)
          commit(
            'UPDATE_LANGUAGE',
            data.data.dataheader.dataheader.language.toUpperCase()
          )
        }
        if (payment.data.billpayment) {
          commit('UPDATE_BILL_PAYMENT', payment.data.billpayment)
        }
        if (master.data.data) {
          commit('UPDATE_MASTER', master.data.data)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        // always executed
        commit('LOAD_DONE')
      })
  },
  getBillData({ commit }, payload) {
    if (payload.page != 'paymentmethods') {
      commit('LOADING')
    }
    commit('UPDATE_LINKCODE', payload.linkcode)
    return PaymentService.getBillData(payload.linkcode)
      .then(function (response) {
        commit('UPDATE_BILL_DATA', response.data)
        let res = response.data.dataheader.dataheader
        if (payload.page == 'paymentsuccess') {
          if (res.redirecturl && parseFloat(res.outstanding) == 0) {
            //router.push(res.redirecturl)
            window.location.href = res.redirecturl
          } else if (parseFloat(res.outstanding) == 0) {
            router.push(`/billRecieve/?linkcode=${payload.linkcode}`)
            //window.location.href = `/billRecieve/?linkcode=${payload.linkcode}`
          } else if (parseFloat(res.outstanding) > 0) {
            router.push(`/paymentMethods/?linkcode=${payload.linkcode}`)
            //window.location.href = `/paymentMethods/?linkcode=${payload.linkcode}`
          }
        } else if (payload.page == 'paymentmethods') {
          if (parseFloat(res.outstanding) == 0) {
            router.push(`/paymentSuccess/?linkcode=${payload.linkcode}`)
            //window.location.href = `/paymentSuccess/?linkcode=${payload.linkcode}`
          }
        }
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        // always executed
        if (payload.page != 'paymentmethods') {
          commit('LOAD_DONE')
        }
      })
  },
  getBillData_v1({ commit }, payload) {
    if (payload.page != 'paymentmethods') {
      commit('LOADING')
    }
    commit('UPDATE_LINKCODE', payload.linkcode)
    return PaymentService.getBillDataValidated(payload.linkcode)
      .then(function (response) {
        commit('UPDATE_BILL_DATA', response.data)
        let res = response.data.dataheader.dataheader
        if (payload.page == 'paymentsuccess') {
          if (res.redirecturl && parseFloat(res.outstanding) == 0) {
            //router.push(res.redirecturl)
            window.location.href = res.redirecturl
          } else if (parseFloat(res.outstanding) == 0) {
            router.push(`/billRecieve/?linkcode=${payload.linkcode}`)
            //window.location.href = `/billRecieve/?linkcode=${payload.linkcode}`
          } else if (parseFloat(res.outstanding) > 0) {
            router.push(`/paymentMethods/?linkcode=${payload.linkcode}`)
            //window.location.href = `/paymentMethods/?linkcode=${payload.linkcode}`
          }
        } else if (payload.page == 'paymentmethods') {
          if (parseFloat(res.outstanding) == 0) {
            router.push(`/paymentSuccess/?linkcode=${payload.linkcode}`)
            //window.location.href = `/paymentSuccess/?linkcode=${payload.linkcode}`
          }
        }
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        // always executed
        if (payload.page != 'paymentmethods') {
          commit('LOAD_DONE')
        }
      })
  },
  getBillDataStatus({ commit }, payload) {
    return PaymentService.getBillData(payload)
      .then(function (response) {
        //commit('UPDATE_BILL_DATA', response.data) Fix Expire after Paid
        commit(
          'UPDATE_BILL_DATA_STATUS',
          response.data.dataheader.dataheader.status
        )
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        // always executed
        commit('LOAD_DONE')
      })
  },
  getQR({ commit }, payload) {
    commit('UPDATE_QR', '')
    if (payload) {
      commit('LOADING')
      if (['CreditQR', 'KCreditQR'].includes(payload.method)) {
        return PaymentService.getQrCredit(
          payload.bubankid,
          payload.refcode,
          payload.amount,
          payload.method
        )
          .then(function (response) {
            if (response.data.status == false) {
              commit('LOAD_DONE')
            } else {
              let imageType = 'png'

              if (payload.method == 'KCreditQR') {
                imageType = 'svg+xml'
              }

              commit('UPDATE_QR', `data:image/${imageType};base64, ` + response.data)
              commit('LOAD_DONE')
            }
            return response
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
            // always executed
          })
      } else if (payload.method == 'SCB Easy') {
        return PaymentService.getSCBEasy(
          payload.bubankid,
          payload.refcode,
          payload.amount
        )
          .then(function (response) {
            window.location.href = response.data
            // commit('UPDATE_QR', response.data)
            commit('LOAD_DONE')
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
            // always executed
          })
        //Fix QR Onward 11/10/24
      } else if (payload.method == 'PPCS') {
        return PaymentService.getPPCSQr(payload.bubankid, payload.refcode, payload.bank)
          .then(function (response) {
            if (response.data.status == false) {
              commit('LOAD_DONE')
            } else {
              if(payload.bank == 'KBANK'){
                commit('UPDATE_QR', 'data:image/svg+xml;base64, ' + response.data)
              }else{
                commit('UPDATE_QR', 'data:image/png;base64, ' + response.data)
              }
              //commit('UPDATE_QR', 'data:image/png;base64, ' + response.data)
              commit('LOAD_DONE')
            }
            return response
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
            // always executed
          })
      } else {
        return PaymentService.getPaymentQr(
          payload.bubankid,
          payload.trantype,
          payload.refcode,
          payload.amount,
          payload.method
        )
          .then(function (response) {
            if (response.data.status == false) {
              commit('LOAD_DONE')
            } else {
              commit(
                'UPDATE_QR',
                payload.method == 'ThaiQR'
                  ? 'data:image/png;base64, ' + response.data
                  : payload.method === 'KThaiQR'
                  ? 'data:image/svg+xml;base64, ' + response.data
                  : payload.method === 'Alipay'
                  ? response.data
                  : //: response.data
                    'data:image/svg+xml;base64, ' +
                    Buffer.from(response.data).toString('base64')
              )
              console.log('QR response ' + response.data)
              commit('LOAD_DONE')
            }
            return response
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  },
  getScbEasyLink({ commit }, payload) {
    commit('UPDATE_SCB_EASY_LINK', '')
    if (payload) {
      commit('LOADING')
      if (payload.method == 'SCB Easy') {
        return PaymentService.getSCBEasy(
          payload.bubankid,
          payload.refcode,
          payload.amount
        )
          .then(function (response) {
            commit('UPDATE_SCB_EASY_LINK', response.data)
            commit('LOAD_DONE')
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
            // always executed
          })
      }
    }
  },

  //Add Payplus Method 04/02/26
  getPayPlusLink({ commit }, payload) {
    commit('UPDATE_PAYPLUS_LINK', '')
    if (payload) {
      commit('LOADING')
      if (payload.method == 'PayPlus') {
        return PaymentService.getPayPlusLink(payload)
          .then(function (response) {
            commit('UPDATE_PAYPLUS_LINK', response.data.redirect_url)
            commit('LOAD_DONE')
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
            // always executed
          })
      }
    }
  },

  getMaster({ commit }, payload) {
    commit('LOADING')
    return PaymentService.getMaster(JSON.stringify(payload))
      .then(function (response) {
        let data = response.data.data
        if (data.GetCardStoreList)
          commit('UPDATE_STORED_CARD', data.GetCardStoreList)
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        commit('LOAD_DONE')
      })
  },
  recieveDepositBillUrl({ commit }, payload) {
    commit('LOADING')
    return PaymentService.recieveDepositBillUrl(payload)
      .then(function (response) {
        if (response.data.status == true || response.data.status == 'true') {
          commit('SET_BILL_URL', response.data.url)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        commit('LOAD_DONE')
      })
  },
  submitCreditCard({ state, commit }, cardInfo) {
    commit('LOADING')
    delete cardInfo['cvv']
    cardInfo = {
      bubankid: state.selectedMethod,
      refcode: state.linkcode,
      ...cardInfo,
    }
    return PaymentService.submitCreditCard(cardInfo)
      .then(function (response) {
        commit('PAYMENT_REQUEST', response.data.data)
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        commit('LOAD_DONE')
      })
  },
  getTwocTwopIntegrate({ state, commit }, cardInfo) {
    commit('LOADING')
    return PaymentService.getTwocTwopIntegrate(cardInfo)
      .then(function (response) {
        commit('PAYMENT_REQUEST', response.data)
        if (response.data.respCode == '0000') {
          window.location.href = response.data.webPaymentUrl
        }
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        commit('LOAD_DONE')
      })
  },
  getDeeplinkIntegrate({ state, commit }, cardInfo) {
    commit('LOADING')
    return PaymentService.getDeeplinkIntegrate(cardInfo)
      .then(function (response) {
        // console.log(response.data)
        if (response.data) {
          commit('PAYMENT_REQUEST', response)
          if (response.data.paymentPage.paymentPageURL) {
            window.location.href = response.data.paymentPage.paymentPageURL
          }
        }
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        commit('LOAD_DONE')
      })
  },
  getKbankCreateCharge({ state, commit }, chargeInfo) {
    commit('LOADING')
    return PaymentService.kbankCreateCharge(chargeInfo)
      .then(function (response) {
        commit('PAYMENT_REQUEST', response.data)
        if (response.data.status == 'success') {
          window.location.href = response.data.redirect_url
        }
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        commit('LOAD_DONE')
      })
  },
}

const getters = {
  splited: (state) => {
    if (!state.billPayment) return state.paycomplete
    return (
      (state.paycomplete && state.billPayment.length >= 2) ||
      (!state.paycomplete && state.billPayment.length >= 1)
    )
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
})
